import React from "react";
import { useTranslation } from "react-i18next";
import Common from "./common";

import home_en from "./images/home_en.png";
import home_fr from "./images/home_fr.png";

const Home = () => {
  const { t, i18n } = useTranslation();

  const language = i18n.language;
  const imageSrc = language === "fr" ? home_fr : home_en;

  return (
    <Common
      name={t('home_title')}
      imgsrc={imageSrc}
      visit="/service"
      btname={t('home_button')}
      subtitle={t("home_subtitle")}
      home="true"
    />
  );
};

export default Home;
